<template>
    <DModal
        :title="isCreate ? __('settings.electronic_invoice_operators.modal.create_modal.title') : __('settings.electronic_invoice_operators.modal.edit_modal.title')"
        is-confirm
        :is-awaiting-validation="true"
        @confirm="submitForm"
        @close="emit('close-modal')"
    >
        <DCard
            padding
        >
            <DFormRow
                :label="__('settings.electronic_invoice_operators.form.name')"
                :error="errors.name"
                is-required
                :hint="__('settings.electronic_invoice_operators.form.name_hint')"
            >
                <DInput
                    id="legal_forms_name"
                    v-model="form.name"
                    :placeholder="__('settings.electronic_invoice_operators.form.name')"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.electronic_invoice_operators.form.identifier')"
                :error="errors.identifier"
                is-required
                :hint="__('settings.electronic_invoice_operators.form.identifier_hint')"
            >
                <DInput
                    id="legal_forms_identifier"
                    v-model="form.identifier"
                    :placeholder="__('settings.electronic_invoice_operators.form.identifier')"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

const props = defineProps({
    operator: {
        type: Object,
        default: () => { return {} }
    },
    isCreate: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['close-modal'])

const form = useForm({
    name: props.operator?.name ?? null,
    identifier: props.operator?.identifier ?? null
})

const errors = ref({})

function submitForm () {
    if (props.isCreate) {
        form.post(route('settings.electronic-invoice-operators.store'), {
            onSuccess: () => {
                emit('close-modal')
            },
            onError: (error) => {
                errors.value = error
            }
        })
    }

    form.put(route('settings.electronic-invoice-operators.update', { operator: props.operator?.id }), {
        onSuccess: () => {
            emit('close-modal')
        },
        onError: (error) => {
            errors.value = error
        }
    })
}
</script>
